export default __webpack_public_path__ + "static/BioRhymeExpanded-ExtraBold-kern-latin-1c9fc9cdda193eb4a7301eaf3f26816a.woff2";